import { DocumentPreviewTypes } from '../types';

const DocumentPreview = ({ className }: DocumentPreviewTypes) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    className={className || ''}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.6 3C39.579 3 42 5.421 42 8.4V39.6C42 42.579 39.579 45 36.6 45H11.4C8.421 45 6 42.579 6 39.6V8.4C6 
      5.421 8.421 3 11.4 3H36.6ZM25.125 30H15.006C14.178 30 13.506 30.672 13.506 31.5C13.506 32.328 14.178 33 
      15.006 33H25.125C25.953 33 26.625 32.328 26.625 31.5C26.625 30.672 25.953 30 25.125 30ZM34.494 25.5C34.494 
      24.672 33.822 24 32.994 24H15.006C14.178 24 13.506 24.672 13.506 25.5C13.506 26.328 14.178 27 15.006 27H32.994C33.822 
      27 34.494 26.328 34.494 25.5ZM32.994 18H15.006C14.178 18 13.506 18.672 13.506 19.5C13.506 20.328 14.178 21 15.006 
      21H32.994C33.822 21 34.494 20.328 34.494 19.5C34.494 18.672 33.822 18 32.994 18ZM34.494 13.5C34.494 12.672 33.822 
      12 32.994 12H15.006C14.178 12 13.506 12.672 13.506 13.5C13.506 14.328 14.178 15 15.006 15H32.994C33.822 15 34.494 
      14.328 34.494 13.5Z"
      fill="#CED3D6"
    />
  </svg>
);

export default DocumentPreview;
